import {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import {
  ApiBlueprint,
  configApiRef,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';

export const byconxForgejoAuthApiRef = createApiRef<
  OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>().with({
  id: 'auth.forgejo',
});

export const byconxForgejoAuthApi = ApiBlueprint.make({
  name: 'forgejo',

  params: defineParams =>
    defineParams({
      api: byconxForgejoAuthApiRef,

      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },

      factory: ({
        discoveryApi,
        oauthRequestApi,
        configApi,
      }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,

          environment:
            configApi.getOptionalString('auth.environment'),

          provider: {
            id: 'oidc',
            title: 'Forgejo',
            icon: () => null,
          },

          defaultScopes: [
            'openid',
            'profile',
            'email',
          ],
        }),
    }),
});
